// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const StandardBoundaries = {
  GemeentegrenzenNl: "Gemeentegrenzen NL",
  BuurtenNl: "Buurten NL",
  RioleringsgebiedenNl: "Rioleringsgebieden NL",
} as const;
export type StandardBoundaries = (typeof StandardBoundaries)[keyof typeof StandardBoundaries];

export function instanceOfStandardBoundaries(value: any): boolean {
  for (const key in StandardBoundaries) {
    if (Object.prototype.hasOwnProperty.call(StandardBoundaries, key)) {
      if (StandardBoundaries[key as keyof typeof StandardBoundaries] === value) {
        return true;
      }
    }
  }
  return false;
}

export function StandardBoundariesFromJSON(json: any): StandardBoundaries {
  return StandardBoundariesFromJSONTyped(json, false);
}

export function StandardBoundariesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): StandardBoundaries {
  return json as StandardBoundaries;
}

export function StandardBoundariesToJSON(value?: StandardBoundaries | null): any {
  return value as any;
}

export function StandardBoundariesToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): StandardBoundaries {
  return value as StandardBoundaries;
}
